import type { ReactElement } from 'react'

import Link from 'next/link'

import { Container } from '@ui/components/Container'
import { Seo } from '@ui/components/seo'
import { HeroBasic } from '@ui/hero'
import { MarketingLayout } from '@ui/layout/MarketingLayout'

const title = 'Legal Notices and Special Disclaimers'
const description = ''

export function Index() {
  return (
    <>
      <Seo title={title} description={description} />
      <div className="relative bg-[url('/img/our-mission-bg.svg')] bg-cover bg-center pt-[120px]">
        <HeroBasic
          className="!bg-transparent"
          title={
            <span className="font-display tracking-wider text-[#0a2d4a]">
              LEGAL NOTICES AND SPECIAL DISCLAIMERS
            </span>
          }
        />
      </div>
      <Container>
        <div className="flex flex-col gap-6 py-20 text-[#0a2d4a]">
          <p>
            Copyright {new Date().getFullYear()} ATM.com, Inc. All rights
            reserved worldwide.
          </p>
          <p>
            ATM.COM<sup>&reg;</sup> and DATA DATING<sup>&reg;</sup> are
            registered trademarks and ANT MONEY<sup>&trade;</sup> is an
            unregistered, common law trademark of ATM.com, Inc. All other
            trademarks are the property of their respective owners. GOOGLE PLAY
            <sup>&reg;</sup> and the Google Play logo are registered trademarks
            of Google, Inc. APPLE
            <sup>&reg;</sup> , the APPLE logo, and IPHONE<sup>&reg;</sup> are
            registered trademarks of Apple, Inc.
          </p>
          <p>
            1. This website is operated by <strong>ATM.com, Inc.</strong>{' '}
            (“ATM”).
          </p>
          <p>
            ATM IS NOT A BROKER DEALER, WE ARE NOT AN INVESTMENT ADVISOR, AND WE
            DO NOT PURPORT TO AND DO NOT, IN ANY FASHION, PROVIDE INVESTMENT
            ADVICE, TAX, ACCOUNTING, ACTUARIAL, RECORDKEEPING, LEGAL,
            BROKER/DEALER OR ANY RELATED SERVICES OR ADVICE. NO CONTENT,
            MATERIALS, OR INSTRUCTIONS SHOULD BE UNDERSTOOD AS CONSTITUTING A
            RECOMMENDATION TO ENTER IN ANY SECURITIES TRANSACTION. WE HAVE NO
            ACCESS TO NON-PUBLIC INFORMATION ABOUT PUBLICLY TRADED COMPANIES,
            AND WE ARE NOT REGULATED BY THE U.S. SECURITIES AND EXCHANGE
            COMMISSION.
          </p>
          <p>
            INFORMATION PROVIDED BY ATM CUSTOMER SUPPORT IS FOR INFORMATIONAL
            AND GENERAL EDUCATIONAL PURPOSES ONLY AND IS NOT INVESTMENT OR
            FINANCIAL ADVICE, OR ANY OTHER TYPE OF PROFESSIONAL ADVICE.
          </p>
          <p>
            2. Investment advisory services are provided exclusively by{' '}
            <strong>Ant Money Advisors, LLC</strong> (“AMA”), an SEC-registered
            investment adviser. AMA PROVIDES NO ASSURANCE, REPRESENTATION OR
            PROMISE REGARDING FUTURE EARNINGS OR INCOME, OR THAT YOU WILL MAKE
            ANY SPECIFIC AMOUNT OF MONEY, OR ANY MONEY AT ALL, OR THAT YOU WILL
            NOT LOSE MONEY. PAST PERFORMANCE IS NOT INDICATIVE OF FUTURE
            RESULTS. YOU SHOULD UNDERTAKE YOUR OWN DUE DILIGENCE REGARDING YOUR
            EVALUATION OF ANY SERVICES AND/OR PRODUCTS PRESENTED ON THIS
            WEBSITE.
          </p>
          <p>
            AMA’s terms and policies can be found at{' '}
            <Link
              href="https://www.antmoneyadvisors.com"
              className="text-blueberry-700 underline"
            >
              www.antmoneyadvisors.com
            </Link>{' '}
            or through{' '}
            <Link
              href="https://www.adviserinfo.sec.gov"
              className="text-blueberry-700 underline"
            >
              www.adviserinfo.sec.gov
            </Link>{' '}
            and our Form CRS can be found{' '}
            <Link
              href="https://www.antmoneyadvisors.com/form-crs-adv-part-3/"
              className="text-blueberry-700 underline"
            >
              here
            </Link>
            . AMA facilitates trading through DriveWealth, LLC, an
            SEC-registered broker-dealer and member FINRA and SIPC. Securities
            in your account protected up to $500,000. For details, please see{' '}
            <Link
              href="https://www.sipc.org"
              className="text-blueberry-700 underline"
            >
              https://www.sipc.org
            </Link>
            . Check the background of this firm on FINRA’s BrokerCheck.
          </p>
        </div>
      </Container>
    </>
  )
}

Index.getLayout = (page: ReactElement) => (
  <MarketingLayout chin="white" mainClassName="-mt-[120px]">
    {page}
  </MarketingLayout>
)

export default Index
